import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { ChatMessage } from 'components';
import moment from 'moment';
import styled from 'styled-components';
var Wrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

function ChatArea(props) {
  var _props$messages = props.messages,
      messages = _props$messages === void 0 ? [] : _props$messages,
      user = props.user;
  return /*#__PURE__*/React.createElement(Wrap, {
    id: "chatAreaWrap"
  }, messages && messages.length ? messages.map(function (message) {
    if (!user) return false;
    var myMessage = parseInt(message.ownerUserId) === parseInt(user.id);
    var formattedTimestamp = moment(message.createdAt).format('dddd, M/DD/YYYY h:mm a');
    return /*#__PURE__*/React.createElement(ChatMessage, {
      style: myMessage ? {
        alignSelf: 'flex-end'
      } : {},
      message: message,
      time: formattedTimestamp,
      self: myMessage
    });
  }) : null);
}

export default ChatArea;